'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var scales = _ref.scales;

  var defaultAppearance = _themer.Themer.createTextDropdownButtonAppearance({
    base: {
      borderRadius: 3
    },
    hover: {},
    focus: {
      boxShadow: '0 0 0 3px ' + scales.primary.P5A
    },
    active: {},
    disabled: {
      opacity: 0.5
    }
  });

  /**
   * Get the appearance of a `TextDropdownButton`.
   */
  var getTextDropdownButtonAppearance = function getTextDropdownButtonAppearance() {
    return defaultAppearance;
  };

  /**
   * Get the className of a `TextDropdownButton`.
   */
  return (0, _memoizeClassName2.default)(getTextDropdownButtonAppearance);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL2Jhc2UvZ2V0VGV4dERyb3Bkb3duQnV0dG9uQ2xhc3NOYW1lLmpzIl0sIm5hbWVzIjpbInNjYWxlcyIsImRlZmF1bHRBcHBlYXJhbmNlIiwiVGhlbWVyIiwiY3JlYXRlVGV4dERyb3Bkb3duQnV0dG9uQXBwZWFyYW5jZSIsImJhc2UiLCJib3JkZXJSYWRpdXMiLCJob3ZlciIsImZvY3VzIiwiYm94U2hhZG93IiwicHJpbWFyeSIsIlA1QSIsImFjdGl2ZSIsImRpc2FibGVkIiwib3BhY2l0eSIsImdldFRleHREcm9wZG93bkJ1dHRvbkFwcGVhcmFuY2UiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOztBQUNBOzs7Ozs7a0JBRWUsZ0JBQWdCO0FBQUEsTUFBYkEsTUFBYSxRQUFiQSxNQUFhOztBQUM3QixNQUFNQyxvQkFBb0JDLGVBQU9DLGtDQUFQLENBQTBDO0FBQ2xFQyxVQUFNO0FBQ0pDLG9CQUFjO0FBRFYsS0FENEQ7QUFJbEVDLFdBQU8sRUFKMkQ7QUFLbEVDLFdBQU87QUFDTEMsZ0NBQXdCUixPQUFPUyxPQUFQLENBQWVDO0FBRGxDLEtBTDJEO0FBUWxFQyxZQUFRLEVBUjBEO0FBU2xFQyxjQUFVO0FBQ1JDLGVBQVM7QUFERDtBQVR3RCxHQUExQyxDQUExQjs7QUFjQTs7O0FBR0EsTUFBTUMsa0NBQWtDLFNBQWxDQSwrQkFBa0MsR0FBTTtBQUM1QyxXQUFPYixpQkFBUDtBQUNELEdBRkQ7O0FBSUE7OztBQUdBLFNBQU8sZ0NBQWlCYSwrQkFBakIsQ0FBUDtBQUNELEMiLCJmaWxlIjoiZ2V0VGV4dERyb3Bkb3duQnV0dG9uQ2xhc3NOYW1lLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVGhlbWVyIH0gZnJvbSAnLi4vLi4vLi4vLi4vdGhlbWVyJ1xuaW1wb3J0IG1lbW9pemVDbGFzc05hbWUgZnJvbSAnLi4vdXRpbHMvbWVtb2l6ZUNsYXNzTmFtZSdcblxuZXhwb3J0IGRlZmF1bHQgKHsgc2NhbGVzIH0pID0+IHtcbiAgY29uc3QgZGVmYXVsdEFwcGVhcmFuY2UgPSBUaGVtZXIuY3JlYXRlVGV4dERyb3Bkb3duQnV0dG9uQXBwZWFyYW5jZSh7XG4gICAgYmFzZToge1xuICAgICAgYm9yZGVyUmFkaXVzOiAzXG4gICAgfSxcbiAgICBob3Zlcjoge30sXG4gICAgZm9jdXM6IHtcbiAgICAgIGJveFNoYWRvdzogYDAgMCAwIDNweCAke3NjYWxlcy5wcmltYXJ5LlA1QX1gXG4gICAgfSxcbiAgICBhY3RpdmU6IHt9LFxuICAgIGRpc2FibGVkOiB7XG4gICAgICBvcGFjaXR5OiAwLjVcbiAgICB9XG4gIH0pXG5cbiAgLyoqXG4gICAqIEdldCB0aGUgYXBwZWFyYW5jZSBvZiBhIGBUZXh0RHJvcGRvd25CdXR0b25gLlxuICAgKi9cbiAgY29uc3QgZ2V0VGV4dERyb3Bkb3duQnV0dG9uQXBwZWFyYW5jZSA9ICgpID0+IHtcbiAgICByZXR1cm4gZGVmYXVsdEFwcGVhcmFuY2VcbiAgfVxuXG4gIC8qKlxuICAgKiBHZXQgdGhlIGNsYXNzTmFtZSBvZiBhIGBUZXh0RHJvcGRvd25CdXR0b25gLlxuICAgKi9cbiAgcmV0dXJuIG1lbW9pemVDbGFzc05hbWUoZ2V0VGV4dERyb3Bkb3duQnV0dG9uQXBwZWFyYW5jZSlcbn1cbiJdfQ==